import {Component, OnInit} from '@angular/core';
import * as  apiVeranstaltungen from '../../../../clients/veranstaltungen';
import {select, Store} from '@ngrx/store';
import * as fromAppState from '../../app-state/app-state.reducer';
import {
    getAktuelleVeranstaltung,
    getAktuelleVeranstaltungenFehler,
    getAktuelleVeranstaltungenLaden, getPlatform, getVeranstaltungDeckblatt
} from '../../app-state/app-state.reducer';
import * as fromChecklistenUebersichtPage from './funktionsbereich-checklisten.reducer';
import 'rxjs/add/observable/fromPromise';
import {Observable } from 'rxjs/Observable';
import * as actionsUi from './funktionsbereich-checklisten.actions.ui';
import {AlertController, LoadingController, Platform} from '@ionic/angular';
import {ActivatedRoute, Router} from '@angular/router';
import {
    PostFunktionsbereichFreigebenAction,
    PostVeranstaltungFreigebenAction,
    PostVeranstaltungPhaseBeendenAction
} from '../../../../client-ngrx/veranstaltungen';
import {takeWhile} from 'rxjs/operators';
import {DocumentService} from '@orga-app/providers/document.service';
import {NotificationService} from '@orga-app/providers/notification.service';
import {File} from '@ionic-native/file/ngx';
import {DocumentViewer, DocumentViewerOptions} from '@ionic-native/document-viewer/ngx';
import {FileOpener} from '@ionic-native/file-opener/ngx';
import {SafeUrl} from '@angular/platform-browser';
import {
    PhaseCheckliste, PhaseFunktionsbereichChecklisten,
    PhasenVeranstaltungFunktionsbereiche,
    VeranstaltungBerechtigung
} from '../../../../clients/veranstaltungen';
import {getVeranstaltungBerechtigung} from '../../app-state/app-state.reducer';
import {SetzeAufgabeAction, SetzeFunktionsbereichChecklisteAction} from '../../app-state/actions/app-state.actions.ui';
import { Settings, SettingsProvider } from '@orga-app/settings';
import {PageStateResetAction} from '../aufgabe/aufgabe.actions.ui';

@Component({
    selector: 'app-funktionsbereiche-checklisten',
    templateUrl: './funktionsbereiche-checklisten.page.html',
})
export class FunktionsbereicheChecklistenPage implements OnInit {
    public settings$: Observable<Settings>;
    public themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;
    public platformState$: Observable<string>;
    public platformState: string;
    public aktuelleVeranstaltung$: Observable<apiVeranstaltungen.Veranstaltung>;
    public aktuelleVeranstaltungDeckblatt$: Observable<apiVeranstaltungen.VeranstaltungDetail>;
    public uiZeigeVeranstaltungenAktuelleLaden$: Observable<boolean>;
    public uiZeigeVeranstaltungenAktuelleLadefehler$: Observable<boolean>;
    public phasenVeranstaltungFunktionsbereiche$: Observable<Array<apiVeranstaltungen.PhasenVeranstaltungFunktionsbereiche>>;
    public uiZeigePhasenVeranstaltungFunktionsbereicheLaden$: Observable<boolean>;
    public uiZeigePhasenVeranstaltungFunktionsbereicheLadefehler$: Observable<boolean>;
    public aiName = 'FunktionsbereicheChecklistenPage';
    public aktuelleVeranstaltung: apiVeranstaltungen.Veranstaltung;
    public aktuelleVeranstaltungId: string;
    public veranstaltungStatus$: Observable<apiVeranstaltungen.VeranstaltungStatus>;
    public alive = true;
    public veranstaltungBerechtigung$: Observable<VeranstaltungBerechtigung>;
    scrollToChecklisteId = 'FunktionsbereichChecklistenPage::scrollToChecklisteId';

    constructor(public alertCtrl: AlertController,
                private store: Store<fromChecklistenUebersichtPage.PageState>,
                private storeVeranstaltung: Store<fromAppState.GlobalAppState>,
                private settingsProvider: SettingsProvider,
                public route: ActivatedRoute,
                public loadingCtrl: LoadingController,
                private documentService: DocumentService,
                private documentViewer: DocumentViewer,
                private notificationService: NotificationService,
                public platform: Platform,
                public file: File,
                private fileOpener: FileOpener,
                public router: Router) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.settingsProvider.getActiveTheme();
    }

    ngOnInit() {
        // Platform from State
        this.platformState$ = this.storeVeranstaltung.pipe(select(getPlatform));

        // Veranstaltung
        this.aktuelleVeranstaltung$ = this.storeVeranstaltung.pipe(select(getAktuelleVeranstaltung));
        this.aktuelleVeranstaltungDeckblatt$ = this.storeVeranstaltung.pipe(select(getVeranstaltungDeckblatt));
        this.uiZeigeVeranstaltungenAktuelleLaden$ = this.storeVeranstaltung.pipe(select(getAktuelleVeranstaltungenLaden));
        this.uiZeigeVeranstaltungenAktuelleLadefehler$ = this.storeVeranstaltung.pipe(select(getAktuelleVeranstaltungenFehler));
        this.veranstaltungBerechtigung$ = this.storeVeranstaltung.pipe(select(getVeranstaltungBerechtigung));

        // Funktionsbereiche Checklisten
        this.phasenVeranstaltungFunktionsbereiche$ = this.store.pipe(select(fromChecklistenUebersichtPage.getPhasenVeranstaltungFunktionsbereiche));
        this.uiZeigePhasenVeranstaltungFunktionsbereicheLaden$ = this.store.pipe(select(fromChecklistenUebersichtPage.getUiZeigePhasenVeranstaltungFunktionsbereicheLaden));
        this.uiZeigePhasenVeranstaltungFunktionsbereicheLadefehler$ = this.store.pipe(select(fromChecklistenUebersichtPage.getUiZeigePhasenVeranstaltungFunktionsbereicheLadefehler));

        // VeranstaltungStatus
        this.veranstaltungStatus$ = this.store.pipe(select(fromChecklistenUebersichtPage.getVeranstaltungStatus));


        this.aktuelleVeranstaltung$.subscribe((aktuelleVeranstaltung) => {
            if (aktuelleVeranstaltung != null) {
                this.aktuelleVeranstaltungId = aktuelleVeranstaltung.veranstaltung_id;
                this.aktuelleVeranstaltung = aktuelleVeranstaltung;
            }
        });

        this.phasenVeranstaltungFunktionsbereiche$.subscribe((x) => {
            if (x) {
                const checklisteId = localStorage.getItem(this.scrollToChecklisteId);
                if (checklisteId) {
                    localStorage.removeItem(this.scrollToChecklisteId);

                    setTimeout(function () {
                        const elmnt = document.getElementById(checklisteId);
                        if (elmnt) {
                            elmnt.scrollIntoView({behavior: 'auto', block: 'center', inline: 'nearest'});
                        }
                    }.bind(this), 800);
                }
            }
        });

        this.platformState$.subscribe(x => {
            this.platformState = x;
            if (x === 'desktop') {
                this.viewWillEnterPage().then();
            }
        }).unsubscribe();
    }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        await this.store.dispatch(new actionsUi.PageStateResetAction());
        await this.checklistenUndVeranstaltungErneutLaden();
    }




    async ladeSpieltag() {
        // this.log.logVerbose("FunktionsbereicheChecklistenPage:: ladeSpieltag");
    }

    async spieltagBeginnen() {
        // this.log.logVerbose("FunktionsbereicheChecklistenPage:: spieltagBeginnen");
    }

    async spieltagFreigeben() {
        // this.log.logVerbose("FunktionsbereicheChecklistenPage:: spieltagFreigeben");
    }

    async spieltagBeenden() {
        // this.log.logVerbose("FunktionsbereicheChecklistenPage:: spieltagBeenden");
    }


    async oeffneCheckliste(funktionsbereich: apiVeranstaltungen.Funktionsbereich, checkliste: apiVeranstaltungen.Checkliste, scrollAnchor: string) {
        localStorage.setItem(this.scrollToChecklisteId, scrollAnchor);
        // this.navCtrl.push(FunktionsbereichChecklistenAufgabenPage, {funktionsbereich, checkliste}, {});
        if (this.platformState === 'desktop') {
            this.storeVeranstaltung.dispatch(new SetzeFunktionsbereichChecklisteAction(funktionsbereich, checkliste));
            this.storeVeranstaltung.dispatch(new SetzeAufgabeAction(null));
            this.store.dispatch(new PageStateResetAction());
        } else {
            await this.router.navigate(['./funktionsbereich/' + funktionsbereich.funktionsbereich_id + '/checkliste/' + checkliste.checkliste_id], {
                relativeTo: this.route,
                // queryParams: {returnUrl: this.router.url.split('?')[0]}
            });
        }
    }

    async checklistenUndVeranstaltungErneutLaden() {
        this.store.dispatch(new actionsUi.PageLoadDataAction());
    }

    async veranstaltungFreigeben(phase: apiVeranstaltungen.Phase) {
        if (this.aktuelleVeranstaltungId != null) {

            const prompt = await this.alertCtrl.create({
                header: 'Veranstaltung freigeben',
                message: 'Soll die Veranstaltung <b>' + this.aktuelleVeranstaltung.titel + '</b> freigegeben werden?',
                buttons: [
                    {
                        text: 'Nein',
                        handler: data => {
                        }
                    },
                    {
                        text: 'Ja',
                        handler: data => {
                            const veranstaltungFreigebenRequest = <apiVeranstaltungen.VeranstaltungPhaseRequest>{
                                veranstaltung_id: this.aktuelleVeranstaltung.veranstaltung_id,
                                zeitpunkt_utc: new Date(),
                                phase_id: phase.phase_id
                            };
                            this.store.dispatch(new PostVeranstaltungFreigebenAction(veranstaltungFreigebenRequest));
                        }
                    }
                ]
            });
            await prompt.present();
        }
    }

    async veranstaltungPhaseBeenden(phase: apiVeranstaltungen.Phase) {
        if (this.aktuelleVeranstaltungId != null) {

            const prompt = await this.alertCtrl.create({
                header: 'Veranstaltung beenden',
                message: 'Soll die Veranstaltung <b>' + this.aktuelleVeranstaltung.titel + '</b> beendet werden?',
                buttons: [
                    {
                        text: 'Nein',
                        handler: data => {
                        }
                    },
                    {
                        text: 'Ja',
                        handler: data => {
                            const veranstaltungPhaseBeendenRequest = <apiVeranstaltungen.VeranstaltungPhaseRequest>{
                                veranstaltung_id: this.aktuelleVeranstaltung.veranstaltung_id,
                                zeitpunkt_utc: new Date(),
                                phase_id: phase.phase_id
                            };
                            this.store.dispatch(new PostVeranstaltungPhaseBeendenAction(veranstaltungPhaseBeendenRequest));
                        }
                    }
                ]
            });
            await prompt.present();
        }
    }

    async funktionsbereichFreigeben(funktionsbereiche: apiVeranstaltungen.Funktionsbereich, phase: apiVeranstaltungen.Phase) {
        if (this.aktuelleVeranstaltungId != null) {
            const prompt = await this.alertCtrl.create({
                header: 'Funktionsbereich freigeben',
                message: 'Bitte nenne den Grund für die Freigabe des Funktionsbereichs <b>' + funktionsbereiche.titel + '</b>',
                inputs: [
                    {
                        name: 'freigabegrund',
                        placeholder: 'Freigabe Grund...',
                        id: 'alertInput'
                    },
                ],
                buttons: [
                    {
                        text: 'Abbrechen',
                        handler: data => {
                        }
                    },
                    {
                        text: 'Freigeben',
                        handler: data => {
                            const funktionsbereichFreigebenRequest = <apiVeranstaltungen.FunktionsbereichFreigebenRequest>{
                                veranstaltung_id: this.aktuelleVeranstaltungId,
                                freigabe_text: data.freigabegrund,
                                funktionsbereich_id: funktionsbereiche.funktionsbereich_id,
                                zeitpunkt_utc: new Date(),
                                phase_id: phase.phase_id
                            };
                            this.store.dispatch(new PostFunktionsbereichFreigebenAction(funktionsbereichFreigebenRequest));
                        }
                    }
                ],
                cssClass: 'alertCustomCss'
            });
            await prompt.present();
        }
    }

    async pageAktualisieren(event) {
        await this.checklistenUndVeranstaltungErneutLaden();
        setTimeout(async function() {
            await event.target.complete(); }.bind(this), 800);
    }

    async funktionsbereichBerichtOeffnen(funktionsbereich: apiVeranstaltungen.Funktionsbereich) {
        const loading = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Prüfbericht für Funktionsbereich ' + funktionsbereich.titel + ' wird geladen'
        });
        await loading.present();

        const url = '/api/query/veranstaltungen/' + funktionsbereich.veranstaltung_id + '/pruefbericht/funktionsbereiche/' + funktionsbereich.funktionsbereich_id;
        this.documentService.getDocument(url).pipe(takeWhile(() => this.alive))
            .subscribe(async (document) => {
                    if (document != null) {
                        await loading.dismiss();

                        if (this.platformState === 'desktop') {
                            this.documentService.saveFile(document, this.replaceSpecialCharacter(funktionsbereich.titel));
                        } else {
                            this.file.removeFile(this.file.dataDirectory, this.replaceSpecialCharacter(funktionsbereich.titel) + '.pdf').then((x) => {
                                this.writeFile(funktionsbereich, document);
                            }).catch((error) => {
                                this.writeFile(funktionsbereich, document);
                            });
                        }

                    }
                },
                error => {
                    this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                    loading.dismiss();
                }, () => {
                });
    }

    async writeFile(funktionsbereich: apiVeranstaltungen.Funktionsbereich, document) {
        const options: DocumentViewerOptions = {
            title: funktionsbereich.titel,
            documentView: {closeLabel: 'Schließen'},
            openWith: {enabled: true},
            email: {enabled: true}
        };

        const y = Observable.fromPromise(this.file.writeFile(this.file.dataDirectory, this.replaceSpecialCharacter(funktionsbereich.titel) + '.pdf', document))
            .subscribe((x) => {
                if (this.platform.is('ios')) {
                    const cacheDirectory = this.file.dataDirectory.replace('file://', '');
                    this.documentViewer.viewDocument(cacheDirectory + this.replaceSpecialCharacter(funktionsbereich.titel) + '.pdf', 'application/pdf', options, this.onShowDocument, this.onCloseDocument, this.onMissingApp, this.onErrorDocument);
                } else {
                    this.fileOpener.open(
                        this.file.dataDirectory + this.replaceSpecialCharacter(funktionsbereich.titel) + '.pdf',
                        'application/pdf'
                    ).then(() => console.debug('File is opened'))
                        .catch(e => {
                            console.debug('Error opening file', e);
                            this.documentViewer.viewDocument(this.file.dataDirectory + this.replaceSpecialCharacter(funktionsbereich.titel) + '.pdf', 'application/pdf', options, this.onShowDocument, this.onCloseDocument, this.onMissingApp, this.onErrorDocument);
                        });
                }

            }, (error) => {
                console.error(error);
                this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
            });
    }

    async onShowDocument() {
    }

    async onCloseDocument() {
    }

    async onMissingApp(appId, installer) {
        if (confirm('Um das PDF ansehen zu können wird die kostenfreie PDF Viewer App benötigt. Jetzt installieren?')) {
            installer();
        }
    }

    async onErrorDocument(error) {
        window.console.error(error);
        await this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
    }


    replaceSpecialCharacter(value: string) {
        return value
            .replace(/ /g, '_')
            .replace(/ä/g, 'ae')
            .replace(/Ä/g, 'Ae')
            .replace(/ü/g, 'ue')
            .replace(/Ü/g, 'Ue')
            .replace(/ö/g, 'oe')
            .replace(/Ö/g, 'Oe')
            .replace(/ß/g, 'ss')
            .replace(/\//g, '-')
            .replace(/\\/g, '-')
            ;
    }

    trackByPhasenVeranstaltungFunktionsbereiche(index: number, feld: PhasenVeranstaltungFunktionsbereiche) {
        return feld.phase.phase_id;
    }

    trackByFunktionsbereiche(index: number, feld: PhaseFunktionsbereichChecklisten) {
        return feld.funktionsbereich.funktionsbereich_id;
    }

    trackByChecklisten(index: number, feld: PhaseCheckliste) {
        return feld.checkliste.checkliste_id;
    }
}
